<div class="c100 p{{percentage | localeNumber: '0,0'}} {{size}} {{skin}} center">
  <div>
    <span>{{percentage | localeNumber: '0,0'}}<span class="cair-color-gray-400">%</span></span>
  </div>
  <div class="slice">
    <div class="bar"></div>
    <div class="fill"></div>
  </div>
</div>
